import {Injectable, Renderer2} from '@angular/core';
import {getTaboolaLoadArticleScript, TaboolaSetupScript} from '@shared/modules/shared-news-detail/taboola/taboola-scripts';
import {SEOService} from '@core/services/seo.service';

@Injectable()
export class TaboolaService {

  private initial = true;

  constructor( private seoService: SEOService ) { }

  public injectScripts(container: HTMLElement, renderer: Renderer2): void {
    if (this.initial) {
      const setupScript = renderer.createElement('script');
      setupScript.innerHTML = TaboolaSetupScript;
      document.head.append(setupScript);
    }
    const articleScript = renderer.createElement('script');
    articleScript.innerHTML = getTaboolaLoadArticleScript(this.initial, this.seoService.currentCanonicalUrl);
    container.append(articleScript);
    this.initial = false;
  }
}
